import { useEffect } from "react";

const SITE_NAME = "Smart Connect Electrical";
const DEFAULT_DESCRIPTION =
  "Premium smart electrical fittings and home automation, engineered for effortless, connected living.";

function setMetaByAttr(attr, key, content) {
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// No react-helmet dependency — this is a CSR-only app (no SSR/prerendering),
// so a plain useEffect mutating document.head covers the same need
// (browser tab titles, share-preview tags) without adding a library whose
// main value (streaming head tags during SSR) doesn't apply here.
export default function useSEO({ title, description, noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Smart Home Electrical Fittings`;
    const desc = description || DEFAULT_DESCRIPTION;

    document.title = fullTitle;
    setMetaByAttr("name", "description", desc);
    setMetaByAttr("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMetaByAttr("property", "og:title", fullTitle);
    setMetaByAttr("property", "og:description", desc);
    setMetaByAttr("name", "twitter:title", fullTitle);
    setMetaByAttr("name", "twitter:description", desc);
  }, [title, description, noindex]);
}
